"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _download = _interopRequireDefault(require("cccisd-icons/download2"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _styles = _interopRequireDefault(require("./styles.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Instructions = /*#__PURE__*/function (_React$Component) {
  function Instructions(props, context) {
    var _this;
    _classCallCheck(this, Instructions);
    _this = _callSuper(this, Instructions, [props, context]);
    _this.state = {
      file: undefined,
      fileColumns: [],
      fileError: '',
      mapping: {},
      isSubmitting: false
    };
    _this.clearFile = _this.clearFile.bind(_this);
    _this.downloadDynamicCsv = _this.downloadDynamicCsv.bind(_this);
    _this.onFileDrop = _this.onFileDrop.bind(_this);
    _this.renderColumnWarnings = _this.renderColumnWarnings.bind(_this);
    _this.renderFileMatchColumn = _this.renderFileMatchColumn.bind(_this);
    _this.renderValidateButton = _this.renderValidateButton.bind(_this);
    _this.submitForValidation = _this.submitForValidation.bind(_this);
    return _this;
  }
  _inherits(Instructions, _React$Component);
  return _createClass(Instructions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        columns = _this$props.columns,
        description = _this$props.description;
      var fileUploader = this._fileUploader();

      // Define columns and data for table
      var _columns = [{
        name: 'definedColumn',
        label: 'Defined Columns',
        render: function render(value, row, callbacks) {
          // If this column is required, display an asterisk
          return row.column + (row.required ? '*' : '');
        }
      }, {
        name: 'fileMatchColumn',
        label: 'Column from File',
        render: this.renderFileMatchColumn
      }, {
        name: 'description',
        label: 'Description'
      }];
      var row = {};
      var _data = columns.filter(function (column) {
        if ({}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI) {
          return false;
        }
        return true;
      }).map(function (column) {
        row = {};
        row.column = column.name;
        row.description = column.description ? column.description : '';
        row.required = !!column.required;
        return row;
      });
      var columnWarnings = this.renderColumnWarnings();
      var validateButton = this.renderValidateButton();
      return /*#__PURE__*/_react["default"].createElement("div", null, description && /*#__PURE__*/_react["default"].createElement("p", null, description), fileUploader, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary",
        onClick: this.downloadDynamicCsv,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_download["default"], {
        spaceRight: true
      }), "Download Template"), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        className: "table table-striped",
        columns: _columns,
        data: _data,
        hideShowingRowsSummary: true,
        rowKey: "column",
        showPerPageOptions: columns.length > 50
      }), columnWarnings, validateButton);
    }

    // BOUND METHODS //////////////////////////////////////////////////////////

    /**
     * Clear the uploaded file and any file columns we parsed from it.
     */
  }, {
    key: "clearFile",
    value: function clearFile() {
      this.setState({
        file: undefined,
        fileColumns: [],
        mapping: {}
      });
    }

    /**
     * Dynamically create a CSV file from the columns prop and initiate its
     * download.
     */
  }, {
    key: "downloadDynamicCsv",
    value: function downloadDynamicCsv() {
      var _this$props2 = this.props,
        bulkType = _this$props2.bulkType,
        columns = _this$props2.columns;
      var columnHeaders = columns.filter(function (column) {
        if ({}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI) {
          return false;
        }
        return true;
      }).map(function (column) {
        return column.name;
      }).join(',');
      var csvContent = columnHeaders + '\r\n';
      var fileName = "example_bulk_".concat(bulkType, ".csv");
      var blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var url = URL.createObjectURL(blob);

        // Create link with appropriate properties
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    /**
     * Associate the selected column with the pre-defined bulk upload column.
     * @param {string} column The name of the pre-defined bulk upload column
     * @param {Object} event The event causing this to fire
     */
  }, {
    key: "mapFileColumnToColumn",
    value: function mapFileColumnToColumn(column, event) {
      // Map the target column to the pre-defined bulk upload column
      this.setState({
        mapping: _objectSpread(_objectSpread({}, this.state.mapping), {}, _defineProperty({}, column, parseInt(event.target.value, 10)))
      });
    }

    /**
     * Handle a drop event from Dropzone.
     *
     * @param {Object[]} accepted The files that meet the Dropzone's criteria
     * @param {Object[]} rejected The files that do not meet the Dropzone's criteria
     */
  }, {
    key: "onFileDrop",
    value: function onFileDrop(accepted, rejected) {
      if (!accepted.length) return;
      var file = accepted[0];
      var reader = new FileReader();
      var $this = this;
      reader.onload = function (event) {
        var text = event.target.result;
        var fileError = '';

        /* if file is not utf-8 encoded, it parses unknown characters
         *   as �
         *   https://discourse.algolia.com/t/csv-import-with-accented-letters/9480
         */
        if (text.includes('�')) {
          fileError = 'Unable to parse file due to an unexpected character. ' + 'Please make sure this file is exported using UTF-8 file format.';
        }
        var matches = text.match(/^(.+?)(?:\r\n|\r|\n)/);
        if (!matches) {
          fileError = text.trim() === '' ? 'Unable to process file because it is blank.' : 'Unable to process file because it has no data rows.';
        }
        var fileColumns = Array.isArray(matches) ? matches[1].split(',') : [];
        // Add a placeholder for columns without a match
        fileColumns.unshift('-- select --');

        // Create mapping for any matching columns
        var mapping = {};
        var comparableColumn = '';
        var comparableFileColumn = '';
        $this.props.columns.forEach(function (column) {
          column = column.name;
          comparableColumn = Instructions._comparableString(column);
          fileColumns.forEach(function (fileColumn, index) {
            comparableFileColumn = Instructions._comparableString(fileColumn);
            if (comparableColumn === comparableFileColumn && mapping[column] === undefined) {
              mapping[column] = index;
            }
          });
        });
        $this.setState({
          file: file,
          fileColumns: fileColumns,
          fileError: fileError,
          mapping: mapping
        });
      };
      reader.readAsText(file);
    }

    /**
     * Show enabled or disabled validate button, depending on state.
     * @return {Object|null}
     */
  }, {
    key: "renderColumnWarnings",
    value: function renderColumnWarnings() {
      var _this2 = this;
      var _this$state = this.state,
        file = _this$state.file,
        fileError = _this$state.fileError;

      // If we don't have a file, we're all done here
      if (!file) return null;
      var errorIcon = /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null));
      var warnIcon = /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-warning"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null));
      if (fileError) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger"
        }, /*#__PURE__*/_react["default"].createElement("p", null, errorIcon, " ", fileError));
      }
      var mapping;
      var ignored = [];
      var required = [];
      this.props.columns.forEach(function (column) {
        mapping = _this2.state.mapping[column.name];
        var hidden = {}.hasOwnProperty.call(column, 'hideInUI') && column.hideInUI;
        if (!column.required && !mapping && !hidden) {
          ignored.push(column.name);
        } else if (column.required && !mapping) {
          required.push(column.name);
        }
      });
      var renderedIgnored = ignored.length === 0 ? null : /*#__PURE__*/_react["default"].createElement("div", null, warnIcon, " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-warning"
      }, "Ignored: "), ignored.join(', '));
      var renderedRequired = required.length === 0 ? null : /*#__PURE__*/_react["default"].createElement("div", null, errorIcon, " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger"
      }, "Unmapped, Required: "), required.join(', '));
      if (renderedIgnored || renderedRequired) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "card card-body ".concat(_styles["default"].columnWarnings)
        }, renderedRequired, renderedIgnored);
      }
      return null;
    }

    /**
     * Used in Table to handle displaying and matching file columns.
     * @param {*} value The value from the data
     * @param {Object} row The row object
     * @param {Object} callbacks An object with callback functions that can be
     *     called when rendering columns and in rowActions
     */
  }, {
    key: "renderFileMatchColumn",
    value: function renderFileMatchColumn(value, row, callbacks) {
      // If we don't have any parsed file columns, we're done here
      if (!(this.state.fileColumns.length > 0)) {
        return '';
      }

      // Let's see if we have a mapping already
      var mapping = this.state.mapping[row.column];
      var defaultValue = mapping ? mapping : undefined;

      // Is this a required field?
      var selectClass = 'form-select';
      if (row.required && defaultValue === undefined) {
        // Indicate that this required field is not yet mapped
        selectClass += ' text-danger';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: selectClass,
        defaultValue: defaultValue,
        onChange: this.mapFileColumnToColumn.bind(this, row.column)
      }, this.state.fileColumns.map(function (fileColumn, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: index
        }, fileColumn);
      })));
    }

    /**
     * Show enabled or disabled validate button, depending on state.
     * @return {Object}
     */
  }, {
    key: "renderValidateButton",
    value: function renderValidateButton() {
      var buttonText = 'Validate';
      var column;
      var disabled = false;
      var hasMapping = false;
      var mapping;
      for (var i = 0; i < this.props.columns.length; i++) {
        column = this.props.columns[i];
        mapping = this.state.mapping[column.name];
        if (mapping) {
          hasMapping = true;
        }
        if (column.required && !mapping) {
          disabled = true;
          break;
        }
      }

      // We cannot allow preflight if there are no mapped columns!
      if (!disabled && !hasMapping || this.state.fileError) {
        disabled = true;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn float-end btn-primary ".concat(_styles["default"].validate),
        disabled: disabled || this.state.isSubmitting,
        onClick: disabled || this.state.isSubmitting ? function () {} : this.submitForValidation,
        type: "button"
      }, buttonText));
    }

    /**
     * Handle submitting data to back end for validation.
     */
  }, {
    key: "submitForValidation",
    value: (function () {
      var _submitForValidation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.state.isSubmitting) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.setState({
                isSubmitting: true
              });
            case 4:
              _context.next = 6;
              return this.props.acceptValidatedFile(this.state.file, this._outputMapping());
            case 6:
              _context.next = 8;
              return this.setState({
                isSubmitting: false
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function submitForValidation() {
        return _submitForValidation.apply(this, arguments);
      }
      return submitForValidation;
    }() // HELPER METHODS /////////////////////////////////////////////////////////
    /**
     * Alter the string in preparation for comparison; lowercases, then removes
     * underscores, spaces, and hyphens.
     * @param {string} original The input string
     * @return {string}
     */
    )
  }, {
    key: "_fileUploader",
    value:
    /**
     * Render the file uploader or, if a file has already been uploaded, a
     * button to remove the file.
     * @return {Object}
     */
    function _fileUploader() {
      if (this.state.file) {
        return (
          /*#__PURE__*/
          // Button to remove the uploaded file (presumably to replace it)
          _react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-secondary ".concat(_styles["default"].removeFile),
            onClick: this.clearFile,
            type: "button"
          }, "Remove ", /*#__PURE__*/_react["default"].createElement("span", {
            className: "text-primary"
          }, this.state.file.name)))
        );
      }
      return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        accept: ".csv,text/csv,text/plain,application/csv,application/vnd.ms-excel",
        type: "file",
        className: _styles["default"].dropzone,
        disablePreview: true,
        multiple: false,
        onDrop: this.onFileDrop
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _styles["default"].dropzoneDescription
      }, "Drag and drop your file here (click to browse)."));
    }

    /**
     * Remove unmapped columns and re-establish 0 indexing.
     * @return {Object}
     */
  }, {
    key: "_outputMapping",
    value: function _outputMapping() {
      var outputMapping = Object.assign({}, this.state.mapping);
      Object.keys(outputMapping).forEach(function (key) {
        if (outputMapping[key] === undefined || outputMapping[key] === 0) {
          delete outputMapping[key];
        } else {
          outputMapping[key] -= 1;
        }
      });
      return outputMapping;
    }
  }], [{
    key: "_comparableString",
    value: function _comparableString(original) {
      return original.toLowerCase().replace(/[_ -]/g, '');
    }
  }]);
}(_react["default"].Component);
_defineProperty(Instructions, "propTypes", {
  /** Send validated file to parent. */
  acceptValidatedFile: _propTypes["default"].func.isRequired,
  /** Indicates what is being bulk uploaded (plural form); part of example csv name. */
  bulkType: _propTypes["default"].string,
  /** Clear validated file from parent. */
  clearValidatedFile: _propTypes["default"].func.isRequired,
  /** Definition of columns included in bulk upload file. */
  columns: _propTypes["default"].array,
  /** The description displayed at top of modal. */
  description: _propTypes["default"].string
});
_defineProperty(Instructions, "defaultProps", {
  bulkType: 'data',
  columns: [],
  description: ''
});
var _default = exports["default"] = Instructions;